import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';
import { formatFilters } from 'utils/prices';
import { components } from '../types';

export const usePricesFilters = () => {
  const { isLoading: isLoadingPricesFilters, data } = useTypedQuery(
    'get',
    '/prices/filters'
  );

  return {
    isLoadingPricesFilters,
    filters: formatFilters(data?.filters || []),
    isCampaign: data?.is_champaign || false,
    networks: data?.networks || []
  };
};

export const usePricesKpi = (): {
  isLoadingKpi: boolean;
  kpis: components['schemas']['PricesWineKpi'][];
} => {
  const { isLoading: isLoadingKpi, data } = useTypedQuery('get', '/prices/kpi');

  return {
    isLoadingKpi,
    kpis: data?.kpis || []
  };
};

export const usePrices = (
  enabled: boolean,
  wine_id?: number,
  vintage?: string
) => {
  const { isLoading: isLoadingPrices, data } = useTypedQuery(
    'get',
    '/prices/data',
    {
      params: {
        query: {
          wine_id: wine_id,
          vintage: vintage
        }
      },
      queryOpts: {
        // Skip if wine_id or vintage are not set
        enabled: enabled,
        // How long to keep stale data in cache
        staleTime: 1000 * 60 * 2
      }
    }
  );
  return {
    isLoadingPrices,
    data
  };
};

export const usePricesCompare = (enabled: boolean, wine_id?: number) => {
  const { isLoading: isLoadingPricesCompare, data } = useTypedQuery(
    'get',
    '/prices/compare',
    {
      params: {
        query: {
          wine_id: wine_id
        }
      },
      queryOpts: {
        // Skip if wine_id or vintage are not set
        enabled: enabled,
        // How long to keep stale data in cache
        staleTime: 1000 * 60 * 2
      }
    }
  );
  return {
    isLoadingPricesCompare,
    data: data?.data || []
  };
};
